import { useQuery } from '@tanstack/vue-query'
import { storeToRefs } from 'pinia'
import { type Ref, computed } from 'vue'

import { useUserInfoLoaded } from '@/composables/use-user-state'
import { useUserStore } from '@/store/user-store/user-store'
import type { LeaderboardEntry } from '@/types'
import { useAPI } from '@/utils/requests/api-plugin'

import { matchUser } from './helpers'

export function useLeaderboardUser(hru: Ref<string>, entries: Ref<LeaderboardEntry[]>) {
    const userStore = useUserStore()
    const { isAuthorized } = storeToRefs(userStore)
    const userInfoLoaded = useUserInfoLoaded()
    const { getGameLeaderboardMe } = useAPI()

    const { data } = useQuery({
        queryKey: computed(() => ['leaderboard-me', hru.value, userStore.user?._id]),
        enabled: computed(() => userInfoLoaded.value && isAuthorized.value && entries.value.length > 0),
        queryFn: async () => {
            const result = await getGameLeaderboardMe(hru.value)
            return result.status === 'ok' ? (result.data.leaderboard?.viewer_position ?? null) : null
        },
    })

    return computed<LeaderboardEntry | null>(() => matchUser(data.value, entries.value))
}
